// extracted by mini-css-extract-plugin
export default {"tableScrollContainer":"TableBody-module__tableScrollContainer--bwBKt","tableScrollContainerInner":"TableBody-module__tableScrollContainerInner--LlFZK"};